import BelieveFundingScreen from 'features/believeFunding/BelieveFundingScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function OnboardingFundingPage() {
  return (
    <PinwheelContextProvider>
      <BelieveFundingScreen />
    </PinwheelContextProvider>
  );
}
